import React from 'react';
import PropTypes from 'prop-types';

const BADGE_BACKGROUND = '#F8DEB0';

export const IconPriorityShipping = ({ size = 22, color = '#EB963C', style }) => (
    <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: size,
            height: size,
            borderRadius: 6,
            backgroundColor: BADGE_BACKGROUND,
            flexShrink: 0,
            ...style
        }}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={Math.round(size * 0.64)}
            height={Math.round(size * 0.64)}
            viewBox="0 0 24 24"
            fill={color}
            aria-hidden="true"
        >
            <path d="M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z" />
        </svg>
    </span>
);

IconPriorityShipping.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    style: PropTypes.object
};

export default IconPriorityShipping;
